interface FeatureSectionProps {
  headline: React.ReactNode;
  description: React.ReactNode;
  image: string;
  alt: string;
}

const FeatureSection = ({ headline, description, image, alt }: FeatureSectionProps) => {
  return (
    <section className="py-28 px-6 md:px-10">
      <div className="max-w-6xl mx-auto flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
        <h2
          className="text-4xl md:text-5xl tracking-tight"
          style={{ fontFamily: "var(--font-display)" }}
        >
          {headline}
        </h2>
        <p className="text-base md:text-lg text-muted-foreground max-w-md md:text-right">
          {description}
        </p>
      </div>

      <div className="max-w-6xl mx-auto rounded-xl overflow-hidden border border-border shadow-2xl shadow-black/50">
        <img
          src={image}
          alt={alt}
          className="w-full"
          loading="lazy"
          decoding="async"
          width={1600}
          height={900}
        />
      </div>
    </section>
  );
};

export default FeatureSection;
